import Vue from 'vue'

export default {

    name: 'DataExtensionField',
    props: ["fieldProperties", "id", "deFormProperties", "fieldDataTypes"],
    data: function() {
        return {
            properties: Vue.util.extend({
                DefaultValue: ""
            }, this.fieldProperties || {})
        }
    },
    methods: {
        editField: function() {
            this.$emit("DataExtensionField:editing", this.id);
        },
        updateField: function() {
            this.$emit("DataExtensionField:update", this.id, this.properties);
        }
    }
};
